import { PLATFORMS } from "shared";

import { Files, GroupExtensionStatus, PAYLOAD_FILE_TYPES } from "./types";

export const INITIAL_FILES: Files = {
    [PAYLOAD_FILE_TYPES.FtFirmwareFileId]: null,
    [PAYLOAD_FILE_TYPES.FtConfigurationFileId]: null,
    [PAYLOAD_FILE_TYPES.FtOneWireAuthorizationListFileId]: null,
    [PAYLOAD_FILE_TYPES.FtBluetoothAuthorizationListFileId]: null,
    [PAYLOAD_FILE_TYPES.FirmwareFileId]: null,
    [PAYLOAD_FILE_TYPES.ConfigurationFileId]: null
};

export const INITIAL_EXTENSION_STATUS: GroupExtensionStatus = {
    [PLATFORMS.Ft]: true,
    [PLATFORMS.Fmx]: false
};
